var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4004 1H2.70893C1.79687 1 1 1.65625 1 2.55759V19.2862C1 20.1924 1.79687 21 2.70893 21H19.3955C20.3125 21 21 20.1871 21 19.2862V2.55759C21.0053 1.65625 20.3125 1 19.4004 1ZM7.19954 17.671H4.33437V8.7625H7.19954V17.671ZM5.86606 7.40804H5.84553C4.92856 7.40804 4.33482 6.72545 4.33482 5.87098C4.33482 5.00089 4.94419 4.33438 5.88169 4.33438C6.81919 4.33438 7.39285 4.99598 7.41338 5.87098C7.41294 6.72545 6.81919 7.40804 5.86606 7.40804ZM17.671 17.671H14.8058V12.8C14.8058 11.633 14.3888 10.8357 13.3522 10.8357C12.5602 10.8357 12.0915 11.3714 11.883 11.8933C11.8049 12.0808 11.7839 12.3362 11.7839 12.5969V17.671H8.91874V8.7625H11.7839V10.0022C12.2009 9.40848 12.8522 8.55402 14.3678 8.55402C16.2486 8.55402 17.6714 9.79375 17.6714 12.4665L17.671 17.671Z",
    stroke: "#F5F4F5",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.64bbd41c.svg";
export { ForwardRef as ReactComponent };